<template>
  <div class="properties-centent kk-checkbox">
    <div class="properties-body">
      <div style="font-size: 18px;font-weight: bold;text-align: center;margin-bottom: 10px; color: #2b5e7d;">
        {{currentForm.name}}
      </div>
      <form-view :base-data="currentForm"></form-view>
    </div>
  </div>
</template>
<script>

import { getAction } from '@/api/manage'
import FormView from '@views/project/components/FormView'

export default {
  name: "CsimVisitFormItem",
  components: {
    FormView
  },
  props: {
    selectForm: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      currentForm: {},
    }
  },
  methods: {
    formPreviewHandle(selectForm){
      getAction('/project/projectForm/getInfoById',{id: selectForm.formId}).then(res=>{
        if(res.success){
          this.currentForm = res.result
        } else {
          this.$message.error(res.message)
        }
      })
    },
  }
};
</script>
